import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { fullName } from "../helpers";
import { Homeowner } from "../types";

type HomeownerSearchSectionProps = {
  search: string;
  homeowners: Homeowner[];
  isLoading: boolean;
  error?: string;
  onSearchChange: (value: string) => void;
  onSelectHomeowner: (homeowner: Homeowner) => void;
};

export const HomeownerSearchSection = ({
  search,
  homeowners,
  isLoading,
  error,
  onSearchChange,
  onSelectHomeowner,
}: HomeownerSearchSectionProps) => (
  <Box bg="white" borderWidth="1px" borderColor="gray.200" rounded="md" p={5}>
    <Heading size="sm" mb={4}>
      Homeowner
    </Heading>
    <FormControl isInvalid={Boolean(error)}>
      <FormLabel htmlFor="homeowner-search">Search homeowners</FormLabel>
      <Input
        id="homeowner-search"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Name, email, or phone number"
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
    {isLoading && (
      <Text color="gray.500" fontSize="sm" mt={3}>
        Searching homeowners...
      </Text>
    )}

    {homeowners.length > 0 && (
      <Stack spacing={3} mt={4}>
        {homeowners.map((homeowner) => (
          <Button
            key={homeowner.id}
            variant="outline"
            justifyContent="flex-start"
            h="auto"
            py={3}
            whiteSpace="normal"
            onClick={() => onSelectHomeowner(homeowner)}
          >
            <Box textAlign="left">
              <Text fontWeight="semibold">{fullName(homeowner)}</Text>
              <Text fontSize="sm" color="gray.600">
                {homeowner.email}{" "}
                {homeowner.phoneNumber ? `· ${homeowner.phoneNumber}` : ""}
              </Text>
            </Box>
          </Button>
        ))}
      </Stack>
    )}
  </Box>
);
